import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clearAllSelectedItemsButtonText: {
		id: 'jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
		defaultMessage: 'Clear selection',
		description: 'Clicking this button will unselect all the selected items in the dropdown',
	},
});
